// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Location: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 50.3"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M36.4 13.2C33.4 6.8 27 2.7 19.9 2.7h-.8c-7 0-13.5 4.1-16.5 10.5s-2 14 2.6 19.4l11.6 13.8c.7.8 1.6 1.3 2.7 1.3 1 0 2-.5 2.7-1.3l11.6-13.8.2-.2c4.4-5.4 5.3-12.9 2.4-19.2zm-4.1 18.1L20.7 45.1c-.6.7-1.8.7-2.3 0L6.7 31.3c-4-4.8-4.9-11.6-2.3-17.3C7 8.3 12.8 4.7 19.1 4.7h.8c6.3 0 12 3.7 14.7 9.3s1.8 12.5-2.3 17.3z"/><path d="M23.2 11.9c-3.6-1.5-7.8-.7-10.5 2.1-2.8 2.8-3.6 6.9-2.1 10.5 1.5 3.6 5 6 8.9 6 5.3 0 9.6-4.4 9.7-9.7 0-3.9-2.4-7.4-6-8.9zm4.2 8.9c0 3.2-1.9 6-4.8 7.3-2.9 1.2-6.3.6-8.6-1.7s-2.9-5.6-1.7-8.6c1.2-2.9 4.1-4.8 7.3-4.8 4.2 0 7.8 3.5 7.8 7.8z"/></svg>;
};

export default React.memo(Location);
